var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 18,
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M3.864 3.864a.9.9 0 0 1 1.272 0L9 7.727l3.864-3.863a.9.9 0 0 1 1.272 1.272L10.274 9l3.864 3.864a.9.9 0 1 1-1.273 1.272L9 10.274l-3.864 3.864a.9.9 0 1 1-1.272-1.273L7.727 9 3.864 5.136a.9.9 0 0 1 0-1.272z",
    fill: "#4318ff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ffa4664d70e60c3abbdbb63fcb6cd255.svg";
export { ForwardRef as ReactComponent };